import React from "react";
import { parseLink } from "./../../ricos-content/lib/nodeUtils";
import { normalizeHref } from "./../../wix-rich-content-common";
import styles from "./url-link-button-scss";
const UrlLinkButton = ({ toolbarItem }) => {
  var _a;
  const selectedUrlLinkData = toolbarItem.attributes.selectedUrlLinkData;
  const dataHook = (_a = toolbarItem.presentation) == null ? void 0 : _a.dataHook;
  const { url = "", rel = "", target = "_self" } = parseLink(selectedUrlLinkData);
  const href = normalizeHref(url);
  return /* @__PURE__ */ React.createElement("div", { className: styles.toolbarUrlContainer }, /* @__PURE__ */ React.createElement(
    "a",
    {
      "data-hook": dataHook,
      href,
      rel,
      target,
      className: styles.toolbarUrl,
      onMouseDown: (event) => event.preventDefault()
    },
    url
  ));
};
export {
  UrlLinkButton
};
//# sourceMappingURL=url-link-button.js.map
